<div class="p-4">
  <div class="relative min-h-8 pb-1">
    <h2
      id="horiz-bars-dialog-title"
      class="m-0 font-[Lato,Helvetica,Arial,sans-serif] text-xl font-normal text-wrap"
    >
      {{ data$()?.title }}
    </h2>

    <button
      mat-icon-button
      type="button"
      class="absolute top-0 right-0 bottom-0 my-auto -translate-y-1 opacity-60 transition-opacity duration-200 hover:opacity-80 focus-visible:ring-2 focus-visible:ring-blue-700 focus-visible:ring-offset-1"
      aria-label="Close dialog"
      (click)="dialogRef.close()"
    >
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>
  <div
    class="max-h-120 min-h-88 overflow-x-visible overflow-y-auto rounded-lg p-4 text-2xl font-normal"
  >
    <figure
      class="m-0"
      [style.height]="chartService$.recommendedHeight$() + 'px'"
    >
      <p id="horiz-bars-chart-desc" class="sr-only">
        {{ chartDescription$() }}
      </p>
      <canvas
        baseChart
        role="img"
        [attr.aria-label]="'Bar chart: ' + chartTitle$()"
        aria-describedby="horiz-bars-chart-desc"
        [type]="chartService$.barChartType"
        [data]="chartService$.barChartData$()"
        [options]="chartService$.barChartOptions"
        [plugins]="chartService$.barChartPlugins"
        (chartClick)="chartService$.chartClicked($event)"
      ></canvas>

      <figcaption class="sr-only">
        <h3 id="horiz-bars-data-table-title">{{ chartTitle$() }} data table</h3>
        <table aria-labelledby="horiz-bars-data-table-title">
          <caption>
            {{
              chartTitle$()
            }}
            data points
          </caption>
          <thead>
            <tr>
              <th scope="col">Label</th>
              @for (column of accessibleChartColumns$(); track $index) {
                <th scope="col">{{ column }}</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of accessibleChartRows$(); track $index) {
              <tr>
                <th scope="row">{{ row.label }}</th>
                @for (value of row.values; track $index) {
                  <td>{{ value }}</td>
                }
              </tr>
            } @empty {
              <tr>
                <td [attr.colspan]="accessibleChartColumns$().length + 1">
                  No chart data available
                </td>
              </tr>
            }
          </tbody>
        </table>
      </figcaption>
    </figure>
  </div>
</div>
